import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { PortalAdminService } from 'src/app/services/portal-admin.service';

@Component({
  selector: 'app-timesheet-categories',
  templateUrl: './timesheet-categories.component.html',
  styleUrls: ['./timesheet-categories.component.css']
})
export class TimesheetCategoriesComponent implements OnInit {
  selected = 'timesheet-categories';
  departments: string[] = [];
  selectedDepartment: string = '';
  isPortalAdmin!: boolean;
  tasks: any[] = [];
  newTaskName: string = '';
  showAddTaskInput: boolean = false;
  isLoadingTasks: boolean = false;
  isLoadingDepartments: boolean = true;
  constructor(private adminService: AdminService, private portalAdminService: PortalAdminService) { }

  ngOnInit(): void {
    this.checkAdminStatus();
  }

  checkAdminStatus() {
    this.isPortalAdmin = false;
    this.portalAdminService.isPortalAdmin()
      .subscribe({
        next: (res: any) => {
          this.isPortalAdmin = !!res;
          if (this.isPortalAdmin) {
            this.loadDepartments();
          }
        },
        error: (error) => {
          console.error('Failed to determine admin status', error);
          this.isPortalAdmin = false;
        }
      });
  }

  loadDepartments(): void {
    this.isLoadingDepartments = true;
    this.adminService.getDepartments().subscribe(response => {
      this.departments = [ ...response.data, 'No Department'];
      if (this.departments.length > 0) {
        this.selectedDepartment = this.departments[0];
        this.onDepartmentChange();
      }
      this.isLoadingDepartments = false;
    }, error => {
      this.isLoadingDepartments = false;
    });
  }

  onDepartmentChange(): void {
    if (this.selectedDepartment) {
      this.isLoadingTasks = true;
      this.adminService.getTasksByDepartment(this.selectedDepartment).subscribe(response => {
        this.tasks = response.data;
        this.isLoadingTasks = false;
      }, () => {
        this.isLoadingTasks = false;
      });
    }
  }

  getSelectedDepartmentName(): string {
    return this.selectedDepartment;
  }

  toggleAddTaskInput(): void {
    this.showAddTaskInput = !this.showAddTaskInput;
    if (!this.showAddTaskInput) {
      this.newTaskName = '';
    }
  }

  cancelAddTask(): void {
    this.newTaskName = '';
    this.showAddTaskInput = false;
  }

  addTask(): void {
    if (this.newTaskName && this.selectedDepartment) {
      this.adminService.addTask(this.selectedDepartment, this.newTaskName).subscribe(() => {
        this.onDepartmentChange(); // Refresh tasks
        this.newTaskName = '';
        this.showAddTaskInput = false;
      });
    }
  }

  deleteTask(taskToDelete: any): void {
    this.adminService.deleteTask(taskToDelete.id).subscribe(() => {
      this.tasks = this.tasks.filter(task => task.id !== taskToDelete.id);
    });
  }
}
